import { Link } from 'react-router-dom';

export default function AboutSection() {
  return (
    <section className="relative w-full py-20 md:py-28 px-6 md:px-10 lg:px-16 bg-background-50">
      <div className="max-w-6xl mx-auto">
        <div className="flex flex-col lg:flex-row lg:items-start gap-12 lg:gap-20">
          <div className="lg:w-2/5 flex flex-col gap-6">
            <span className="inline-block text-xs font-semibold tracking-widest uppercase text-foreground-400">
              About System
            </span>

            <div className="grid grid-cols-2 gap-3">
              <div className="rounded-xl overflow-hidden h-40">
                <img
                  src="https://readdy.ai/api/search-image?query=Elegant%20workspace%20detail%20shot%20of%20hands%20typing%20on%20laptop%20keyboard%20with%20spreadsheet%20visible%20on%20screen%2C%20soft%20natural%20light%20from%20window%20creating%20gentle%20shadows%20on%20cream%20desk%20surface%2C%20warm%20oatmeal%20and%20beige%20tones%2C%20professional%20yet%20intimate%20photography%20style%2C%20shallow%20depth%20of%20field%20focusing%20on%20screen%20content&width=600&height=800&seq=about-left-v2a&orientation=portrait"
                  alt="Oopbuyspreadsheet workspace detail"
                  className="w-full h-full object-cover"
                />
              </div>
              <div className="rounded-xl overflow-hidden h-40 mt-6">
                <img
                  src="https://readdy.ai/api/search-image?query=Close%20up%20of%20organized%20desk%20with%20color%20coded%20folders%20sticky%20notes%20and%20modern%20calculator%20next%20to%20steaming%20coffee%2C%20warm%20morning%20light%2C%20cream%20and%20sage%20green%20color%20scheme%2C%20minimalist%20productive%20workspace%20aesthetic%2C%20soft%20focus%20background%2C%20editorial%20photography&width=600&height=800&seq=about-right-v2b&orientation=portrait"
                  alt="Organized tracking desk setup"
                  className="w-full h-full object-cover"
                />
              </div>
              <div className="rounded-xl overflow-hidden h-48 col-span-2">
                <img
                  src="https://readdy.ai/api/search-image?query=Wide%20shot%20of%20bright%20modern%20home%20office%20with%20large%20monitor%20displaying%20data%20dashboard%2C%20fashion%20moodboard%20on%20wall%2C%20plants%20and%20natural%20textures%20throughout%2C%20warm%20cream%20and%20terracotta%20palette%2C%20Scandinavian%20interior%20design%2C%20soft%20diffused%20daylight%2C%20aspirational%20workspace%20photography&width=1200&height=600&seq=about-wide-v2c&orientation=landscape"
                  alt="Modern workspace with oopbuyspreadsheet dashboard"
                  className="w-full h-full object-cover"
                />
              </div>
            </div>
          </div>

          <div className="lg:w-3/5">
            <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-950 leading-tight mb-6">
              What is Oopbuyspreadsheet?
              <br />
              <span className="text-primary-500">Ultimate Guide</span> for Smart Buyers
            </h2>
            <p className="text-base md:text-lg text-foreground-600 leading-relaxed mb-5">
              Oopbuyspreadsheet is a revolutionary tracking system designed specifically for modern buyers who demand precision in their purchasing workflow. Unlike generic tools, the oopbuy spreadsheet system combines intelligent automation with intuitive design, making it the go-to solution for fashion buyers, sneaker resellers, electronics sourcers, and bulk purchasing professionals.
            </p>
            <p className="text-base md:text-lg text-foreground-600 leading-relaxed mb-8">
              Every year, buyers lose thousands of dollars to poor tracking, forgotten orders, and miscalculated costs. Oopbuyspreadsheet eliminates these pain points with automated cost calculations, real-time order status updates, and a comprehensive dashboard that puts you in complete control.
            </p>
            <div className="flex flex-col sm:flex-row gap-3">
              <Link
                to="/article/what-is-oopbuyspreadsheet"
                className="inline-flex items-center gap-2 px-5 py-2.5 rounded-full bg-foreground-950 text-background-50 text-sm font-medium hover:bg-foreground-800 transition-colors cursor-pointer whitespace-nowrap"
              >
                Read Full Guide
                <i className="ri-arrow-right-line"></i>
              </Link>
              <Link
                to="/article/oopbuyspreadsheet-beginner-guide"
                className="inline-flex items-center gap-2 px-5 py-2.5 rounded-full border border-foreground-200 text-foreground-700 text-sm font-medium hover:bg-background-100 transition-colors cursor-pointer whitespace-nowrap"
              >
                Beginner Guide
                <i className="ri-arrow-right-line"></i>
              </Link>
              <Link
                to="/article/oopbuyspreadsheet-templates"
                className="inline-flex items-center gap-2 px-5 py-2.5 rounded-full border border-foreground-200 text-foreground-700 text-sm font-medium hover:bg-background-100 transition-colors cursor-pointer whitespace-nowrap"
              >
                Free Templates
                <i className="ri-download-line"></i>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}